<script>
  import { getContext } from "svelte";
  import SidebarSection from "./SidebarSection.svelte";
  import ProfileIcon from "@local/assets/icons/profile.svg";
  import SelectInput from "./SelectInput.svelte";
  import TextInput from "./TextInput.svelte";
  import ContactInput from "#lib/sidebar/ContactInput.svelte";
  import MapboxInput from "./MapboxInput.svelte";
  import ContenteditableInput from "./ContenteditableInput.svelte";
  import getAssignToOptions from "#src/extensions/assign-to-options.js";
  import { profile } from "#src/stores/auth.js";

  export let disabled = false;
  export let group;

  const org = getContext("org");

  $: assignToOptions = $profile ? getAssignToOptions($profile, $org) : [];

  function updateProp(prop, value) {
    group.updateJobProp(prop, value);
  }
</script>

<SidebarSection>
  <SelectInput
    labelWidth="5rem"
    label="Assigned To"
    options={assignToOptions}
    placeholder="Unassigned"
    value={$group.job.assigned_to_id}
    showCaret
    on:input={(e) => updateProp({ assigned_to_id: e.detail.value })}>
    <div slot="selected" let:option class="flex items-center gap-1">
      {#if option.initials}
        <div
          class="profile-circle relative"
          style="background-color: {option.color || '#000'}; border-color: {option.color || '#000'}">
          {option.initials}
        </div>
      {/if}
      <div class:text-gray-400={!option.value}>
        {option.label}
      </div>
    </div>
    <div slot="option" let:option class="flex items-center gap-1 overflow-hidden">
      {#if option.initials}
        <div
          class="profile-circle relative"
          style="background-color: {option.color || '#000'}; border-color: {option.color || '#000'}">
          {option.initials}
        </div>
      {:else}
        <div class="flex-none h-4 w-4" />
      {/if}
      <div class:text-gray-400={!option.value} class="truncate">
        {option.label}
      </div>
    </div>
  </SelectInput>
  <TextInput
    {disabled}
    label="Name"
    labelWidth="5rem"
    value={$group.job.name}
    on:input={(e) => updateProp("name", e.detail.value)} />
  {#if $org.crm_integration_id}
    <ContactInput
      label="Customer"
      labelWidth="5rem"
      value={$group.job.customer_record}
      on:input={(e) => updateProp("customer_record", e.detail.contact)}
      placeholder="Customer"
      orgid={$org.id} />
  {:else}
    <TextInput
      label="Customer"
      labelWidth="5rem"
      value={$group.job.customer_text}
      on:input={(e) => updateProp("customer_text", e.detail.value)} />
  {/if}
  <MapboxInput
    {disabled}
    label="Location"
    labelWidth="5rem"
    value={$group.job.location}
    coordinates={$group.job.location_coordinates}
    on:input={(e) =>
      updateProp({
        location: e.detail.value,
        location_coordinates: e.detail.coordinates,
        location_postal_code: e.detail.postal_code,
        location_country_code: e.detail.country_code,
      })} />
  <ContenteditableInput
    {disabled}
    label="Notes"
    labelWidth="5rem"
    value={$group.job.notes}
    on:input={(e) => updateProp("notes", e.detail.value)} />
</SidebarSection>
